module.exports = __webpack_public_path__ + "img/foot_logo.69480bc2.svg";